import studyResultApi from '@/services/studyResult/studyResultApi'

const state = {
    details: {},   // { [rsHash]: { subject, summary, items } }
}

const mutations = {
    SET_DETAIL(state, { rs, detail }) {
        state.details = { ...state.details, [rs]: detail }
    },
}

const actions = {
    async fetchMarkahKomponen({ commit }, rs) {
        const detail = await studyResultApi.fetchMarkahKomponen(rs)
        commit('SET_DETAIL', { rs, detail })   // commit ก่อน return
        return detail
    },
}

export default {
    namespaced: true,
    state,
    getters: {},
    mutations,
    actions,
}
